const initialState = {
  loading: false,
  username: null,
  secretQuestionCode: null,
  usernamePrefill: null,
  verificationData: null,
  resetSuccess: false,
  error: null
};

export const REQUEST_VERIFICATION_DATA_REQUEST =
  "password/REQUEST_VERIFICATION_DATA_REQUEST";
export const REQUEST_VERIFICATION_DATA_SUCCESS =
  "password/REQUEST_VERIFICATION_DATA_SUCCESS";
export const REQUEST_VERIFICATION_DATA_FAILURE =
  "password/REQUEST_VERIFICATION_DATA_FAILURE";

export const SUBMIT_VERIFICATION_DATA_REQUEST =
  "password/SUBMIT_VERIFICATION_DATA_REQUEST";
export const SUBMIT_VERIFICATION_DATA_SUCCESS =
  "password/SUBMIT_VERIFICATION_DATA_SUCCESS";
export const SUBMIT_VERIFICATION_DATA_FAILURE =
  "password/SUBMIT_VERIFICATION_DATA_FAILURE";

export const RESET_PASSWORD_REQUEST = "password/RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "password/RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "password/RESET_PASSWORD_FAILURE";

export const CLEAR_RESET_PASSWORD_STATE = "password/CLEAR_RESET_PASSWORD_STATE";

export const requestVerificationDataRequest = () => ({
  type: REQUEST_VERIFICATION_DATA_REQUEST
});

/**
 * Creates action for verification data success.
 * @param {object} data data from the verification request
 */
export const requestVerificationDataSuccess = data => ({
  type: REQUEST_VERIFICATION_DATA_SUCCESS,
  payload: data
});

/**
 * Creates action for verification data failure.
 * @param {string} error The error describing why the code request failed.
 */
export const requestVerificationDataFailure = error => ({
  type: REQUEST_VERIFICATION_DATA_FAILURE,
  payload: error
});

export const submitVerificationDataRequest = () => ({
  type: SUBMIT_VERIFICATION_DATA_REQUEST
});

/**
 * Creates action for success of submitting verification data
 * @param {string} data The verification code successfully submitted
 */
export const submitVerificationDataSuccess = data => ({
  type: SUBMIT_VERIFICATION_DATA_SUCCESS,
  payload: data
});

/**
 * Creates action for failure of submitting verification data
 * @param {string} error The error describe why submitting the data failed
 */
export const submitVerificationDataFailure = error => ({
  type: SUBMIT_VERIFICATION_DATA_FAILURE,
  payload: error
});

export const resetPasswordRequest = () => ({
  type: RESET_PASSWORD_REQUEST
});

export const resetPasswordSuccess = () => ({
  type: RESET_PASSWORD_SUCCESS
});

export const clearResetPasswordState = () => ({
  type: CLEAR_RESET_PASSWORD_STATE
});

/**
 * Creates action for failure of resetting the password
 * @param {string} error The error describe why resetting the password failed
 */
export const resetPasswordFailure = error => ({
  type: RESET_PASSWORD_FAILURE,
  payload: error
});

export default function reducer(state = initialState, action = {}) {
  switch (action?.type) {
    case REQUEST_VERIFICATION_DATA_REQUEST:
    case SUBMIT_VERIFICATION_DATA_REQUEST:
    case RESET_PASSWORD_REQUEST:
      return { ...state, loading: true };
    case REQUEST_VERIFICATION_DATA_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        ...action.payload
      };
    case SUBMIT_VERIFICATION_DATA_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        verificationData: action.payload
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        resetSuccess: true
      };
    case REQUEST_VERIFICATION_DATA_FAILURE:
    case SUBMIT_VERIFICATION_DATA_FAILURE:
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CLEAR_RESET_PASSWORD_STATE:
      return {
        ...initialState,
        usernamePrefill: state.username
      };
    default:
      return state;
  }
}

const getResetSubstate = selector => state => {
  return selector(state.password.reset);
};

export const getResetError = getResetSubstate(({ error }) => error);

export const getUsername = getResetSubstate(({ username }) => username);

export const getVerificationDataRequestSuccess = getResetSubstate(
  ({ username }) => Boolean(username)
);

export const getSecretQuestionCode = getResetSubstate(
  ({ secretQuestionCode }) => secretQuestionCode
);

export const getVerificationData = getResetSubstate(
  ({ verificationData }) => verificationData
);

export const getVerificationDataSubmitSuccess = getResetSubstate(
  ({ verificationData }) => Boolean(verificationData)
);

export const getResetSuccess = getResetSubstate(
  ({ resetSuccess, username, verificationData }) =>
    Boolean(resetSuccess && username && verificationData)
);

export const getUsernamePrefill = getResetSubstate(
  ({ usernamePrefill }) => usernamePrefill
);
